/**
 * @fileoverview Custom Refinement List Module for InstantSearch.js.
 * Implements a custom refinement list connector and rendering function for InstantSearch.js.
 */

import {connectRefinementList} from "instantsearch.js/es/connectors";

/**
 * Renders a custom refinement list.
 * This function is used as a connector for the refinement list widget in InstantSearch.js.
 * It generates a list of refinement options (filters) for users to select.
 *
 * @param {Object} renderOptions - The options and utilities provided by InstantSearch.js for rendering the widget.
 * @param {boolean} isFirstRender - Indicates if this is the first render of the widget.
 */
const renderRefinementList = (renderOptions, isFirstRender) => {
    const {items, refine, widgetParams} = renderOptions;
    const {container, updatePreviousRefinementValue, getPreviousRefinementValue} = widgetParams;
    document.querySelector('#resource-type-refinement-container').innerHTML = `
        <div class="flex">
              ${items
        .map(
            item => `
            <div class="mr-12 pb-4 ${item.isRefined ? ' border-b-4' : ''}">
              <a href="#" data-value="${item.value}">
                ${item.label}
              </a>
            </div>`
        )
        .join('')}
</div>

</div>  `;

    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            const previousValue = getPreviousRefinementValue();
            const value = event.currentTarget.dataset.value;

            if (previousValue && previousValue !== value) {
                refine(previousValue);
            }

            if (previousValue !== value) {
                refine(value);
            }

            updatePreviousRefinementValue(value);
        });
    });
};

/**
 * Custom Refinement List Connector using InstantSearch.js's connectRefinementList.
 * This creates a custom refinement list widget for InstantSearch.js implementations.
 */
const customRefinementList = connectRefinementList(renderRefinementList);

/**
 * Refinement Component function.
 * Initializes the custom refinement list widget with specified options.
 *
 * @param {Object} data - Configuration data for the widget.
 * @returns {Function} A function that creates the custom refinement list widget.
 */
export const refinementComponent = (data) => {
    const {updatePreviousRefinementValue, getPreviousRefinementValue} = data;

    return customRefinementList({
        container: document.querySelector(data["componentSelector"]),
        attribute: data["attribute"],
        sortBy: data['sortBy'],
        updatePreviousRefinementValue,
        getPreviousRefinementValue,
    });
};